import React, { useEffect, useState } from "react";
import "./SubheaderInPageLinks.scss";
import { useSelector } from "react-redux";

function SubheaderInPageLinks(props) {
    const isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);
    var activeID = useState(0);

    function subHeadButtonClicked(sect) {
        var offset = 0;

        switch (sect) {
            case "overview":
                offset = props.overview.current.offsetLeft;
                break;
            case "trails":
                offset = props.trails.current.offsetLeft;
                break;
            case "area":
                offset = props.area.current.offsetLeft;
                break;
            case "amenities":
                offset = props.amenities.current.offsetLeft;
                break;
        }

        props.underViewport.current.scroll({
            left: offset,
            behavior: "smooth",
        });
    }

    return (
        <div
            className={`subheader-in-page-links area-subheader${isTouchScreen ? " touchscreen" : ""}`}
            ref={props.areaLinkContainer}
        >
            <button onClick={() => subHeadButtonClicked("overview")}>
                Overview
            </button>
            <button onClick={() => subHeadButtonClicked("trails")}>
                Trails
            </button>
            <button onClick={() => subHeadButtonClicked("area")}>Area</button>
            <button onClick={() => subHeadButtonClicked("amenities")}>
                Amenities
            </button>
        </div>
    );
}

export default SubheaderInPageLinks;
